import { render } from "./StepButton.vue?vue&type=template&id=86e0d6e6"
import script from "./StepButton.vue?vue&type=script&lang=ts"
export * from "./StepButton.vue?vue&type=script&lang=ts"
script.render = render

export default script